// extracted by mini-css-extract-plugin
export var card = "carousel-module--card--O1a3t";
export var content = "carousel-module--content--6e5T4";
export var country = "carousel-module--country---lB-D";
export var name = "carousel-module--name--6LG3h";
export var swiperContainer = "carousel-module--swiperContainer--Y5gfl";
export var wrapper = "carousel-module--wrapper--jNw1d";